import Base from './Base';
import AircallNumber from '../models/AircallNumber';

export default class AircallNumbers extends Base {
    get models() {
        const collection = this.data.map((item) => new AircallNumber(item));
        collection.collection = this;

        return collection;
    }
}
